import { IComponentDto, IComponentSetDto, IUserSettingDto } from "@kuika/kuika-cl-model";
import jsonStringifySafe from "json-stringify-safe";
import * as React from "react";
import { ComponentService } from "../../../../services/component-service";
import { ComponentSetService } from "../../../../services/component-set-service";
import { UserSettingService } from "../../../../services/user-setting-service";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { IWithHistoryProp, withHistory } from "../../../../shared/hoc/with-history";
import { withManagement } from "../../../../shared/hoc/with-management";
import { resolveLoadingPresentation } from "../../../../shared/utility/first-load-skeletons";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { DeleteModal } from "../../../common/delete-modal";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaComponentIcon from "../../../ui-kit/kuika-component-icon/kuika-component-icon";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";
import { KuikaSkeletonList, KuikaSkeletonRegion } from "../../../ui-kit/kuika-skeleton/kuika-skeleton";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import KuikaTabContent from "../../../ui-kit/kuika-tab-content/kuika-tab-content";
import KuikaTabs from "../../../ui-kit/kuika-tabs/kuika-tabs";
import KuikaText from "../../../ui-kit/typography/Text/Text";
import { ComponentDetail } from "./component-detail";
export interface IComponentDefListState {
  triggerComponentDeleteModal: boolean;
  componentToDelete: IComponentDto;
  componentList: IComponentDto[];
  searchComponentString: string;
  isComponentRenaming: boolean;
  renamingComponentId: string;
  componentSetList: IComponentSetDto[];
  selectedComponentSet: IComponentSetDto;
  isDataLoading: boolean;
  selectedComponentId: IComponentDto;
  isComponentImportModalOpen: boolean;
  searchComponentSetString: string;
  isComponentDetailOpen: boolean;
  selectedCategory: "Design" | "Report" | "Deprecated";
}

export interface IComponentDefListProps {}

/** The category tabs in their on-screen order, so the cards slide the way the selection moved. */
const COMPONENT_CATEGORIES: string[] = ["Design", "Report", "Deprecated"];

class ComponentDefList extends React.PureComponent<
  IComponentDefListProps & IWithContextProp & IWithHistoryProp,
  IComponentDefListState
> {
  nameInput: HTMLInputElement | null | undefined;

  constructor(props: IComponentDefListProps & IWithContextProp & IWithHistoryProp) {
    super(props);
    this.state = {
      triggerComponentDeleteModal: false,
      componentToDelete: {} as IComponentDto,
      componentList: [],
      searchComponentString: "",
      isComponentRenaming: false,
      renamingComponentId: "",
      componentSetList: [],
      selectedComponentSet: {} as IComponentSetDto,
      isDataLoading: false,
      selectedComponentId: {} as IComponentDto,
      isComponentImportModalOpen: false,
      searchComponentSetString: "",
      isComponentDetailOpen: false,
      selectedCategory: "Design"
    };
  }

  async componentDidMount() {
    await this.loadComponentSetList();
  }

  async reloadComponentSet() {
    try {
      if (this.state?.selectedComponentSet?.id) {
        this.setState({ isDataLoading: true });
        // const res = await ComponentSetService.Get(this.state.selectedComponentSet.id);
        // if (res && res.status === 200) {
        //   let csObj = res.data as IComponentSetDto;
        //   this.setState({ selectedComponentSet: csObj, isDataLoading: false });
        // }

        const componentsRes = await ComponentService.GetAllByComponentSetId(this.state.selectedComponentSet.id);
        if (componentsRes.status === 200) {
          const cObj = componentsRes.data as IComponentDto[];
          this.setState({ componentList: cObj, isDataLoading: false });
        }
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  setSelectedComponentSet = async (componentSet) => {
    if (componentSet) {
      this.setState(
        {
          componentList: [],
          selectedComponentSet: componentSet
        },
        () => {
          this.reloadComponentSet();
        }
      );
    }
  };

  getComponentSetIdFromLocation() {
    const csIdx = window.location.pathname.indexOf("componentlist/");
    if (csIdx > -1) {
      const csId = window.location.pathname.substring(csIdx + 14, window.location.pathname.length);
      return csId;
    }
    return "";
  }

  async loadComponentSetList() {
    try {
      const res = await ComponentSetService.Get("4bd34537-525c-4a7c-dde0-08d911312c71");
      if (res && res.status === 200) {
        const list = [] as IComponentSetDto[];
        list.push(res.data);
        if (!list || list.length < 1) {
          return;
        }
        this.setState({ componentSetList: list }, () => {
          const csId = this.getComponentSetIdFromLocation();
          if (csId && csId.length > 0) {
            const csItem = list.find((p) => p.id === csId);
            if (csItem) {
              this.setSelectedComponentSet(csItem);
              return;
            }
          }
          this.setSelectedComponentSet(list[0]);
        });
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  async deleteComponent() {
    try {
      const response = await ComponentService.Delete(this.state.componentToDelete.id);
      if (response === true) {
        this.reloadComponentSet();
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  renameComponent = async (e, c: IComponentDto) => {
    e.stopPropagation();
    this.setState(
      {
        isComponentRenaming: true,
        renamingComponentId: c.id
      },
      () => {
        this.nameInput?.focus();
      }
    );
  };

  triggerDeleteComponentModal = (e, c: IComponentDto) => {
    e.stopPropagation();
    this.setState({ triggerComponentDeleteModal: true, componentToDelete: c });
  };

  saveLastUsedComponentSetId = () => {
    try {
      const obj = {} as IUserSettingDto;
      obj.lastUsedComponentSet_Id = this.state.selectedComponentSet.id;
      UserSettingService.Update(obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  };

  handleNewComponent = () => {
    this.saveLastUsedComponentSetId();
    this.openComponentModalForCreate();
  };

  handleImportComponent = () => {
    this.saveLastUsedComponentSetId();
    this.openComponentImportModal();
  };

  handleCategoryChange = (value: string) => {
    this.setState({ selectedCategory: value as "Design" | "Report" | "Deprecated" });
  };

  handleComponentNameKeypress = async (e, c: IComponentDto) => {
    if (e.keyCode === 13) {
      const newName = e.target.value;
      this.renameComponentAction(c, newName);
    } else if (e.keyCode === 27) {
      this.setState({ isComponentRenaming: false });
    }
  };

  handleComponentNameOnBlur = async (e, c: IComponentDto) => {
    const newName = e.target.value;
    this.renameComponentAction(c, newName);
  };

  renameComponentAction = async (c: IComponentDto, newName: string) => {
    try {
      if (newName?.length > 0) {
        // Start from the full loaded row (it carries backend-only fields like Purpose/DesignGuidance
        // that IComponentDto doesn't declare) rather than `{}` — the backend's Update overwrites the
        // whole stored record from the request body, so a name-and-json-only payload used to blank them.
        const obj: IComponentDto = { ...c };
        obj.name = newName;

        if (c.json) {
          const parsedJson = JSON.parse(c.json);
          parsedJson.name = newName;
          obj.json = jsonStringifySafe(parsedJson);
        }
        if (newName !== c.name) {
          await ComponentService.Update(c.id, obj);
          this.reloadComponentSet();
        }
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    } finally {
      this.setState({ isComponentRenaming: false });
    }
  };

  handleComponentSetChange = async (value: string) => {
    this.props.navigator.gotoComponentList(value);
    await this.loadComponentSetList();
  };

  openComponentModalForCreate = () => {
    this.reloadComponentSet();
    this.setState({ selectedComponentId: {} as any, isComponentDetailOpen: true });
  };

  openComponentImportModal = () => {
    this.setState({ isComponentImportModalOpen: true });
  };

  openComponentModalForEdit = (componentId: IComponentDto) => {
    this.setState({ selectedComponentId: componentId, isComponentDetailOpen: true });
  };

  closeComponentModal = () => {
    if (!this.state.selectedComponentId.id) {
      this.setState({ selectedComponentId: {} as IComponentDto, isComponentDetailOpen: false });
    } else {
      this.setState({ isComponentDetailOpen: false }, this.reloadComponentSet);
    }
  };

  closeComponentImportModal = () => {
    this.setState({ isComponentImportModalOpen: false }, () => {
      this.reloadComponentSet();
    });
  };

  clearComponentSetSearchInputOnEscKey = (e) => {
    if (e.keyCode === 27) {
      this.setState({ searchComponentSetString: "" });
    }
  };

  clearComponentSearchInputOnEscKey = (e) => {
    if (e.keyCode === 27) {
      this.setState({ searchComponentString: "" });
    }
  };

  handleTurnBack = () => {
    this.setState({ isComponentDetailOpen: false });
    this.reloadComponentSet();
  };

  isComponentDeprecated = (comp: IComponentDto) => {
    if (comp.json?.length > 0) {
      const parsedJson = JSON.parse(comp.json);
      if (parsedJson.isDeprecated === true) return true;
    }
    return false;
  };

  isComponentReportDesign = (comp: IComponentDto) => {
    if (comp.json?.length > 0) {
      const parsedJson = JSON.parse(comp.json);
      if (parsedJson.isReportDesignComponent === true) return true;
    }
    return false;
  };

  handleCardKeyDown = (e: React.KeyboardEvent<HTMLDivElement>, c: IComponentDto) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      this.openComponentModalForEdit(c);
    }
  };

  handleActionKeyDown = (e: React.KeyboardEvent<HTMLDivElement>, action: "rename" | "delete", c: IComponentDto) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (action === "rename") {
        this.renameComponent(e as any, c);
      } else if (action === "delete") {
        this.triggerDeleteComponentModal(e as any, c);
      }
    }
  };

  /** The loaded components of one category, filtered by the search box and sorted by name. */
  private getComponentsIn = (category: string): IComponentDto[] =>
    (this.state.componentList ?? [])
      .slice()
      .sort((a, b) => (a && a.name ? a.name.localeCompare(b.name) : -1))
      .filter((x) => x.name.toLowerCase().indexOf(this.state.searchComponentString.toLowerCase()) !== -1)
      .filter((c) => {
        const isDeprecated = this.isComponentDeprecated(c);
        const isReport = this.isComponentReportDesign(c);
        if (category === "Deprecated") return isDeprecated;
        if (category === "Report") return isReport;
        return !isDeprecated && !isReport;
      });

  /** One category's cards. Rendered per pane, so a leaving pane keeps drawing its own category. */
  private renderComponentGrid = (category: string): JSX.Element => {
    const components: IComponentDto[] = this.getComponentsIn(category);
    return (
      <div className="component-def-grid">
        {components.length === 0 ? (
          <div className="component-def-empty" role="status" aria-live="polite" style={{ padding: 16 }}>
            <KuikaText>No components found</KuikaText>
          </div>
        ) : (
          components?.map((c) => {
            const isDeprecated = this.isComponentDeprecated(c);
            const isReport = this.isComponentReportDesign(c);
            const cardClass = `component-def-card${isDeprecated ? " component-def-card--deprecated" : ""}${
              isReport ? " component-def-card--report" : ""
            }`;
            return (
              <div
                key={c.id}
                className={cardClass}
                role="button"
                tabIndex={0}
                aria-label={`Open ${c.name}`}
                onClick={() => {
                  this.openComponentModalForEdit(c);
                }}
                onKeyDown={(e) => this.handleCardKeyDown(e, c)}
              >
                <div className="component-def-card__main">
                  <div className="component-def-card__icon">
                    <KuikaComponentIcon name={JSON.parse(c.json).icon || "default"} width={24} height={24} />
                  </div>
                  <div className="component-def-card__name">
                    {!(this.state.isComponentRenaming === true && this.state.renamingComponentId === c.id) && (
                      <KuikaText
                        className={`kuika_projectBrowserScreenName${isDeprecated ? " kuika_text--strike" : ""}`}
                      >
                        {c.name}
                      </KuikaText>
                    )}
                    {this.state.isComponentRenaming === true && this.state.renamingComponentId === c.id && (
                      <div onClick={(e) => e.stopPropagation()}>
                        <KuikaInput
                          className="kuika_management_screen_rename_input"
                          onKeyDown={(e) => {
                            this.handleComponentNameKeypress(e, c);
                          }}
                          ref={(input) => {
                            this.nameInput = input as any;
                          }}
                          onBlur={(e) => {
                            this.handleComponentNameOnBlur(e, c);
                          }}
                          defaultValue={c.name}
                        />
                      </div>
                    )}
                  </div>
                </div>
                {(!this.state.selectedComponentSet.isPublic ||
                  KMainFunctions.isUserKuikaDeveloper(this.props.context?.userInfo?.username)) && (
                  <div className="component-def-card__actions">
                    <KuikaButton type="tertiary" size="md" isIcon onClick={(e) => this.renameComponent(e, c)}>
                      <KuikaSvg name="edit" />
                    </KuikaButton>
                    <KuikaButton
                      type="tertiary"
                      size="md"
                      isIcon
                      onClick={(e) => this.triggerDeleteComponentModal(e, c)}
                    >
                      <KuikaSvg name="trash" color="var(--red-5)" />
                    </KuikaButton>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    );
  };

  render() {
    return (
      <>
        <DeleteModal
          itemName={this.state.componentToDelete.name}
          triggerModal={this.state.triggerComponentDeleteModal}
          deleteItem={() => this.deleteComponent()}
          deleteType={"component"}
          closeModal={() => this.setState({ triggerComponentDeleteModal: false })}
        />
        <div style={{ padding: 16 }}>
          {this.state.isComponentDetailOpen === false && (
            <div
              style={{ display: "flex", justifyContent: "space-between", marginBottom: "32px", alignItems: "center" }}
            >
              <div style={{ display: "flex" }}>
                <KuikaInput
                  aria-label="Search components"
                  placeholder="Search component..."
                  value={this.state.searchComponentString}
                  onChange={(e) => this.setState({ searchComponentString: e.target.value })}
                  onKeyDown={(e) => {
                    this.clearComponentSearchInputOnEscKey(e);
                  }}
                />

                <div role="tablist" aria-label="Component categories" style={{ marginLeft: "24px", minWidth: 280 }}>
                  <KuikaTabs
                    options={COMPONENT_CATEGORIES}
                    value={this.state.selectedCategory}
                    onChange={this.handleCategoryChange}
                  />
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <KuikaButton
                  type="primary"
                  size="md"
                  uppercase
                  className="kuika_management_new_button"
                  onClick={this.handleNewComponent}
                >
                  NEW COMPONENT
                </KuikaButton>
              </div>
            </div>
          )}

          {resolveLoadingPresentation(this.state.isDataLoading, (this.state.componentList?.length ?? 0) > 0) ===
          "skeleton" ? (
            // Only while the set's components are not there yet (a set was just picked). A reload
            // after a rename, delete or save keeps the cards on screen instead of dissolving them
            // into shimmer, and no longer darkens the whole page for a list this size (L7).
            <KuikaSkeletonRegion label="Loading components">
              <KuikaSkeletonList rows={6} withIcon />
            </KuikaSkeletonRegion>
          ) : (
            <div className="component-def-container">
              {this.state.isComponentDetailOpen && (
                <div className="component-def-list__back">
                  <KuikaButton
                    data-testid="componentDefTurnBackButton"
                    type="tertiary"
                    color="neutral"
                    size="sm"
                    onClick={this.handleTurnBack}
                  >
                    <span className="component-def-list__back-inner">
                      <KuikaSvg name="chevron-left" width={16} height={16} color="var(--dark-7)" />
                      Back to components
                    </span>
                  </KuikaButton>
                </div>
              )}

              {this.state.isComponentDetailOpen === false && (
                <KuikaTabContent
                  activeKey={this.state.selectedCategory}
                  order={COMPONENT_CATEGORIES}
                  render={this.renderComponentGrid}
                />
              )}

              {this.state.isComponentDetailOpen && (
                <ComponentDetail
                  selectedComponentSet={this.state.selectedComponentSet}
                  componentId={this.state.selectedComponentId}
                  turnBack={this.handleTurnBack}
                />
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}

const componentDefList = withContext<IComponentDefListProps>(
  withHistory<IComponentDefListProps>(withManagement<IComponentDefListProps>(ComponentDefList))
);
export { componentDefList as ComponentDefList };
